module.exports = __webpack_public_path__ + "static/media/david.65404d03.jpg";